var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex":"auto"}},[_c('empty-state',{attrs:{"icon":"mdi-arrow-up","message":_vm.$t('default.please-select-a-shift-to-begin')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }